import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('cable')

export default {
  namespaced: true,
  state: {
    cables: [],
  },
  mutations: {
    setCable: (state, data) => { state.cables = data }
  },
  actions: {
    getCables: async ({commit}) => {
      try {
        const response = await api.get('cable/list')
        // console.log("cables :", response.data)
        commit('setCable', response.data)
      } catch (e) {
        console.error('[axios] getCables :', e.message)
      }
    },
  }
}
